module.exports = __webpack_public_path__ + "media/images/technical-expertise-449a8b287976f48839bebdd9a792b442.jpg";